import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { memoize } from "@smithy/property-provider";
import bowser from "bowser";
import { DEFAULTS_MODE_OPTIONS } from "./constants";
export var resolveDefaultsModeConfig = function resolveDefaultsModeConfig() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    defaultsMode = _ref.defaultsMode;
  return memoize( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var mode;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof defaultsMode === "function")) {
              _context.next = 6;
              break;
            }
            _context.next = 3;
            return defaultsMode();
          case 3:
            _context.t0 = _context.sent;
            _context.next = 7;
            break;
          case 6:
            _context.t0 = defaultsMode;
          case 7:
            mode = _context.t0;
            _context.t1 = mode === null || mode === void 0 ? void 0 : mode.toLowerCase();
            _context.next = _context.t1 === "auto" ? 11 : _context.t1 === "mobile" ? 12 : _context.t1 === "in-region" ? 12 : _context.t1 === "cross-region" ? 12 : _context.t1 === "standard" ? 12 : _context.t1 === "legacy" ? 12 : _context.t1 === undefined ? 13 : 14;
            break;
          case 11:
            return _context.abrupt("return", Promise.resolve(isMobileBrowser() ? "mobile" : "standard"));
          case 12:
            return _context.abrupt("return", Promise.resolve(mode === null || mode === void 0 ? void 0 : mode.toLocaleLowerCase()));
          case 13:
            return _context.abrupt("return", Promise.resolve("legacy"));
          case 14:
            throw new Error("Invalid parameter for \"defaultsMode\", expect ".concat(DEFAULTS_MODE_OPTIONS.join(", "), ", got ").concat(mode));
          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));
};
var isMobileBrowser = function isMobileBrowser() {
  var _window, _window$navigator, _parsedUA$platform;
  var parsedUA = typeof window !== "undefined" && (_window = window) !== null && _window !== void 0 && (_window$navigator = _window.navigator) !== null && _window$navigator !== void 0 && _window$navigator.userAgent ? bowser.parse(window.navigator.userAgent) : undefined;
  var platform = parsedUA === null || parsedUA === void 0 ? void 0 : (_parsedUA$platform = parsedUA.platform) === null || _parsedUA$platform === void 0 ? void 0 : _parsedUA$platform.type;
  return platform === "tablet" || platform === "mobile";
};